<template>
    <v-container class="p-relative">
        <v-row>
            <v-col cols="12" md="12" class="py-0">
                <RegistryHeader
                    :title="getPriceListRegistry.name"
                    :avatarData="getPriceListRegistry.currentMenager"
                    @clearSearch="clearTable"
                />
                <Table
                 :title="getPriceListRegistry.name"
                    :items="getPriceListTable.items"
                    :headers="headers"
                    :length="getPriceListTable.pages"
                    :page="getPriceListTable.page"
                    @search="setSearch"
                    @clear-table="clearTable"
                    @search-fields="setSearchFields"
                    @change-page="setPage"
                    @sort="setSort"
                    :defaultFields="getPriceListSearchFields.searchFields"
                    :loading="getPriceListTable.loading"
                >
                    <Columns slot="columns" :items="getPriceListTable.items" />
                </Table>
                <Modal
                    :title="$t('price-list:addingPriceList')"
                    :open="open"
                    :height="'640'"
                    v-on:close="closeModal"
                >
                    <AEContent slot="AEContent" />
                    <Buttons
                        :action="'create'"
                        slot="buttons"
                        @closeModal="open = false"
                    />
                </Modal>
                <div class="d-flex justify-end buttons--action">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                data-cy="addEntry"
                                fab
                                dark
                                v-on="on"
                                small
                                v-if="add()"
                                @click="addPriceList()"
                                class="buttons--add margin--1"
                            >
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('price-list:addPriceList') }}</span>
                    </v-tooltip>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import store from './../../../store/index'
import Columns from '../../../components/Registries/Price-list/Table/Columns'
import AEContent from './../../../components/Registries/Price-list/Modal/Content'
import Buttons from './../../../components/Registries/Price-list/Modal/Buttons'
export default {
    data() {
        return {
            open: false,
            headers: [
                {
                    text: this.$t('price-list:index'),
                    value: 'index',
                    width: '10%',
                    showSearch: true,
                },
                {
                    text: this.$t('price-list:createdAt'),
                    value: 'createdAt',
                    width: '10%',
                },
                {
                    text: this.$t('price-list:contractor'),
                    value: 'contractor.name',
                    width: '29%',
                    showSearch: true,
                },
                {
                    text: this.$t('price-list:title'),
                    value: 'title',
                    width: '30%',
                    showSearch: true,
                },
                {
                    text: this.$t('price-list:updatedAt'),
                    value: 'updatedAt',
                    width: '14%',
                },
                {
                    text: this.$t('price-list:status'),
                    value: 'status.name',
                    width: '100px',
                    showSearch: true,
                },
                {
                    text: '',
                    value: 'arrow',
                    align: 'right',
                    width: '150px',
                    sortable: false,
                },
            ],
        }
    },
    components: {
        Columns,
        AEContent,
        Buttons,
    },
    computed: {
        ...mapGetters([
            'getPriceListRegistry',
            'getPriceListTable',
            'getPriceListSearchFields',
            'getSearch',
        ]),
    },
    methods: {
        ...mapActions(['fetchPriceListTable', 'fetchUsers']),
        ...mapMutations([
            'clearPriceListModal',
            'clearPriceListErrors',
            'setPriceListTable',
            'clearPriceListTable',
            'setPriceListSearch',
        ]),
        add() {
            return this.checkPermissions('CREATE')
        },
        closeModal() {
            // this.clearCarsErrors()
            this.open = false
        },
        async addPriceList() {
            this.open = true
            this.clearPriceListErrors()
            this.clearPriceListModal()
        },
        setSearchFields(searchFields) {
            this.setPriceListSearch(searchFields)
        },
        setSearch(search) {
            this.setPriceListTable({ search, page: 1 })
            this.fetchPriceListTable()
        },
        setPage(page) {
            this.setPriceListTable({ page })
            this.fetchPriceListTable()
        },
        setSort(sort) {
            this.setPriceListTable({ sort })
            this.fetchPriceListTable()
        },
        clearTable() {
            this.getSearch.text = ''
            this.clearPriceListTable()
            this.fetchPriceListTable()
        },
    },
    beforeRouteEnter(to, from, next) {
        if (from.matched[1] && from.matched[1].path !== '/price-list/:id')
            store.commit('clearPriceListTable')
        store.dispatch('fetchPriceListTable').then(() => next())
    },
}
</script>
